import React from 'react'
import { Link } from 'react-router-dom'

export interface NestedLinkProps {
  icon: React.ReactNode
  label: string
  path: string
  active?: boolean
}

const NestedLink = ({ icon, label, path, active = false }: NestedLinkProps): JSX.Element => {
  return (
    <Link
      to={path}
      style={{ backgroundColor: active ? '#3582CE' : 'transparent' }}
      className="self-stretch py-2 rounded-md inline-flex justify-start items-center px-2 pr-0">
      <div className="w-6 h-6 flex justify-center items-center">
        <div style={{ color: active ? 'white' : '#52525B' }} className="relative">
          {icon}
        </div>
      </div>
      <div className="flex-1 pl-1 pr-2 py-1 rounded-md flex justify-start items-center gap-2 overflow-hidden">
        <div
          style={{
            color: active ? 'white' : '#52525B',
            fontWeight: active ? 'bold' : 'normal'
          }}
          className="flex-1 justify-start text-[11px] font-medium font-Montserrat leading-tight">
          {label}
        </div>
      </div>
    </Link>
  )
}

export default NestedLink
